import { useContext } from 'react';
import type { PortalCapabilities } from './capabilities';
import type {
  ImpersonationPartnerOption,
  PortalActor,
  PortalEffectiveSubject,
  PortalViewAsTarget,
} from './portalSession';
import { PortalSessionContext } from './portalSessionContext';

export type PortalSessionState = 'loading' | 'ready' | 'unauthorized' | 'error';

export type PortalSessionContextValue = {
  state: PortalSessionState;
  isRefreshing: boolean;
  error?: Error | null;
  actor: PortalActor | null;
  viewAsTarget: PortalViewAsTarget;
  setViewAsTarget(target: PortalViewAsTarget): void;
  viewAsOptions: ImpersonationPartnerOption[];
  effective: PortalEffectiveSubject | null;
  capabilities: PortalCapabilities;
  refresh(): Promise<void>;
};

export function usePortalSession(): PortalSessionContextValue {
  const context = useContext(PortalSessionContext);
  if (!context) {
    throw new Error('usePortalSession must be used within a PortalSessionProvider');
  }
  return context;
}
